module.exports = __webpack_public_path__ + "img/card1.eee1a9bf.svg";